import { FileMetaData } from '@inno-sdks/files'
import {
  Archive,
  Audio,
  ClusterDocs as ClusterDocsFileIcon,
  ClusterDraw,
  ClusterSheets,
  ClusterSlides,
  FileIconProps,
  Image,
  None,
  PDF,
  Text,
  Video
} from '@inno-ui/file-icons'
import { QuestionCircleLineIcon } from '@inno-ui/icons'
import { mimeTypes } from 'modules/desktop/modules/files-integration/constants'

const mapFileIcon = (key: keyof typeof mimeTypes, icon: FileIconProps) =>
  Object.values(mimeTypes[key]).reduce<Record<string, FileIconProps>>(
    (icons, mimeType) => ({ ...icons, [mimeType]: icon }),
    {}
  )

export const getFileIcon = ({ mimeType }: FileMetaData) => {
  if (!mimeType) {
    return None
  }

  const iconsMap: Record<string, FileIconProps> = {
    ...mapFileIcon('document', ClusterDocsFileIcon),
    ...mapFileIcon('plainDocument', Text),
    ...mapFileIcon('spreadsheet', ClusterSheets),
    ...mapFileIcon('pdf', PDF),
    ...mapFileIcon('presentation', ClusterSlides),
    ...mapFileIcon('diagram', ClusterDraw),
    ...mapFileIcon('drawing', ClusterDraw),
    ...mapFileIcon('image', Image),
    ...mapFileIcon('audio', Audio),
    ...mapFileIcon('video', Video),
    ...mapFileIcon('archive', Archive),
    ...mapFileIcon('other', None),
    'application/x-zip-compressed': Archive,
    'audio/x-flac': Audio
  }

  return iconsMap[mimeType] || QuestionCircleLineIcon
}
